import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ReceiptService } from '../../../../../services/receipt.service';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { ConfigService } from '../../../../../services/endpoint.config.service';
import { LocationService } from '../../../../../services/location.service';
import { DocumentService } from '../../../../../services/document.service';
import { TranslateService } from '@ngx-translate/core';
import { ExpressAccountingService } from '../../../../../services/express-accounting.service';
import { debug } from 'console';
import { log } from 'util';
import { forEach } from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';
import { json } from 'body-parser';

declare let $: any;

interface ICreditCardDetails {
  TerminalNumber: string;
  AuthorizationCode: string;
  CreditCardNumber: string;
  RRN: string;
  CreditCardType: {
    CreditCardTypeId: number;
    Description: string;
  }
}

interface IDetails {
  type: 'cc' | 'cash';
  receiptPaymentTypeId: number;
  description: string;
  details?: ICreditCardDetails;
}

interface IPaymentDetails {
  currency: string;
  shipments: string[];
  paymentDetails: IDetails;
}

@Component({
  selector: 'receipt-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {

  @Input() shippments: any;
  @Input() shipmentsByCurrency: any;
  @Input() hasInboundShipment: any;
  @Input() hasPackagingShipment: any;
  @Input() hasOutboundShipment: any;
  @Input() OutboundIDScanRequired: any;
  @Input() PODIDScanRequired: any;
  @Input() PODSignatureRequired: any;
  @Input() consigneeObject;
  @Input() files: any;
  ccSelected: string = '';
  cashSelected: string = 'selected';
  qrSelected: string = '';
  allTotal: any;
  isTotalZero: boolean = false;
  creditCardTypes: any = [];
  creditCardTypeId: any = -1;
  terminalNumber: any = '';
  authorizationCode: any = '';
  creditCardNumber: any = '';
  rrn: any = null;
  isPaymentSuccess: boolean = false;
  showRetry: boolean = false;
  disableChoosrCridt: boolean = true;
  base64Output: string;
  branchCurrencyCode: string = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
  CreaditCardEnabaled: boolean = true;
  isCheckoutButtonDisabled: boolean = false;

  sss: any;

  displayCurrency: string;
  paymentDetailsByCurrency: IPaymentDetails[] = [];
  isLastCurrency = false;
  @Output() previousTrigger = new EventEmitter()


  isSpotter: boolean = JSON.parse(sessionStorage.getItem('user')).Network.NetworkId != 1;
  qrLink: string = '';

  constructor(
    private receiptService: ReceiptService,
    private router: Router,
    private toaster: ToastrService,
    private DocumentService: DocumentService,
    private loader: NgxUiLoaderService,
    private locationService: LocationService,
    private configs: ConfigService,
    private translate: TranslateService,
    private changeDetection: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private expressAccountingService: ExpressAccountingService) { }

  ngOnInit() {
    if (this.shipmentsByCurrency) {
      const totalCurrency = Object.keys(this.shipmentsByCurrency).length;
      this.displayCurrency = Object.keys(this.shipmentsByCurrency)[0];
      this.isLastCurrency = this.displayCurrency == Object.keys(this.shipmentsByCurrency)[totalCurrency - 1];
    }

    if (this.shippments?.inbound) {
      this.PopUpforCODshipments(this.shippments.inbound);
    }
    if (this.shippments?.outbound) {
      console.log('inside if condition for outbound');

      this.PopUpforCODshipments(this.shippments.outbound);
    }

    this.sss = $("#dvamxprint").amxPrintMngr('992ada1b68b34b618173a221393ba8ce', this.configs.getEnviromentId());
    this.sss.start();
    this.sss.result = function (e) {
      var y = e;
    };

    this.getCreditCardTypes();
    var total = this.findAllTotal2('misc') + this.findAllTotal2('inbound') + this.findAllTotal2('outbound') + this.findAllTotal2('dropoff') + this.findAllTotal2('Packaging');

    if (total == 0) {
      this.checkOut();
    }
  }

  PopUpforCODshipments(Shipments: any[] | undefined) {
    if (!Array.isArray(Shipments)) {
      console.warn("Shipments is not an array:", Shipments);
      return;
    }

    const branchSettingsRaw = sessionStorage.getItem('branchSettings');
    if (!branchSettingsRaw) {
      console.warn("No branchSettings found in sessionStorage");
      return;
    }

    const branchSettings = JSON.parse(branchSettingsRaw);
    const setting = branchSettings.find((item: any) => item.Key === 45);
    const shipperNumberFrCODPopup = setting?.Value;

    if (!shipperNumberFrCODPopup) {
      console.warn("No Value found for Key 45 in branchSettings");
      return;
    }

    for (let i = 0; i < Shipments.length; i++) {
      const shipment = Shipments[i];
      const services = String(shipment?.Shipment?.Services ?? "").trim().toUpperCase();
      const productGroup = String(shipment?.Shipment?.ProductGroup ?? "").trim().toUpperCase();
      const AccountNumber = String(shipment?.Shipment?.ShipperAccountNumber ?? "").trim().toUpperCase();


      if (services === "CODS" || services === "CODS," && productGroup === "DOM" && AccountNumber === shipperNumberFrCODPopup) {
        this.CreaditCardEnabaled = false;

        this.snackBar.open("You can't use Credit Card", "Close", {
          duration: 3000,
          panelClass: ['error-snackbar']
        });

        console.log("Credit Card disabled due to COD shipment restriction");
        return;
      }
    }
  }



  getAwbByCurrency(type: string) {
    return Array.from(this.shipmentsByCurrency[this.displayCurrency]).filter((x: any) => x.type == type.toLowerCase()).map((x: any) => x.shipmentNo).join(', ');
  }

  onNextClick() {
    if (this.openPosCalculator()) {
      return;
    }
    const totalCurrency = Object.keys(this.shipmentsByCurrency).length;
    let keys = Object.keys(this.shipmentsByCurrency);
    const isUpdate = this.updatePaymentDetails();

    if (isUpdate === false) {
      return;
    }

    let nextIndex = keys.indexOf(this.displayCurrency) + 1;
    if (nextIndex <= totalCurrency) {
      this.displayCurrency = keys[nextIndex];
    }
    this.selectPaymentType('cash');
    this.payingAmount = '0';
    this.isLastCurrency = this.displayCurrency == Object.keys(this.shipmentsByCurrency)[totalCurrency - 1];
  }

  updatePaymentDetails() {
    const isPaymentDetailsIndex = this.paymentDetailsByCurrency.findIndex((item) => item.currency === this.displayCurrency);

    const obj: IPaymentDetails = {
      currency: this.displayCurrency,
      shipments: Array.from(this.shipmentsByCurrency[this.displayCurrency]).map((x: any) => x.shipmentNo),
      paymentDetails: {
        type: this.paymentType == 'cash' || this.paymentType == 'qr' ? 'cash' : 'cc',
        receiptPaymentTypeId: this.paymentType == 'cash' || this.paymentType == 'qr' ? 1 : 2,
        description: this.paymentType == 'cash' || this.paymentType == 'qr' ? 'Cash' : 'Credit Card'
      }
    };

    //this is for CreditCard
    if (obj.paymentDetails.type == 'cc') {
      if (this.creditCardDetailsValidation()) {
        return false;
      } else {
        if (this.creditCardTypeId != -1)
          var creditCardDescription = this.creditCardTypes.filter(x => x.CreditCardTypeId == this.creditCardTypeId)[0].Description;

        obj.paymentDetails.details = {
          TerminalNumber: this.terminalNumber,
          AuthorizationCode: this.authorizationCode,
          CreditCardNumber: this.creditCardNumber,
          RRN: this.rrn == null ? "" : this.rrn,
          CreditCardType: {
            CreditCardTypeId: this.creditCardTypeId,
            Description: creditCardDescription
          }
        }
      }
    }
    if (isPaymentDetailsIndex > -1) {
      this.paymentDetailsByCurrency[isPaymentDetailsIndex] = obj;
    } else {
      this.paymentDetailsByCurrency.push(obj);
    }

    return true;
  }

  findTotal(mode, typeOf, of) {
    var total = 0;
    if (typeOf == 'Amount') {

      console.log(this.shippments);

      this.shippments[mode].forEach((item) => {
        try {
          if (item[typeOf] != null && item[typeOf] != undefined) {
            var c = item[typeOf];
            total += Number(c)
          }
        }
        catch (ex) { }
      })
    }
    else {
      this.shippments[mode].forEach((item) => {
        try {
          if (item[typeOf][of] != null && item[typeOf][of] != undefined) {
            var c = item[typeOf][of];
            total += Number(c)
          }
        }
        catch (ex) { }
      })
    }
    return Number(total);
  }
  fixDecimals(value: any = 0) {
    if (value != 0 && value != null) {
      value = parseFloat(value).toFixed(2);
      return value;
    }
    else {
      if (value || value == 0)
        return '0.00';
      else
        return '';
    }
  }
  findAllTotal() {

    this.allTotal = this.findAllTotal2('inbound') + this.findAllTotal2('outbound') + this.findAllTotal2('misc') + this.findAllTotal2('dropoff') + this.findAllTotal2('Packaging');
    if (this.allTotal == 0)
      this.isTotalZero = true;
    else
      this.isTotalZero = false;

    return this.allTotal;
  }

  findVerticalTotal(type, index) {
    if (type == 'misc') {
      return Number(this.shippments[type][index].Amount);
    } else if (type == 'inbound') {
      this.shippments[type][index].Shipment.CashOnDelivery.Value = this.shippments[type][index].Shipment.CashOnDelivery.Value == undefined ? 0 : this.shippments[type][index].Shipment.CashOnDelivery.Value
      this.shippments[type][index].Shipment.RatedPrice.Value = this.shippments[type][index].Shipment.RatedPrice.Value == undefined ? 0 : this.shippments[type][index].Shipment.RatedPrice.Value
      return Number(this.shippments[type][index].Shipment.Customs.Value) + Number(this.shippments[type][index].Shipment.CashOnDelivery.Value) + Number(this.shippments[type][index].Shipment.RatedPrice.Value) + Number(this.shippments[type][index].Shipment.TaxAmount.Value);
    }
    else if (type == 'dropoff') {
      return Number(this.shippments[type][index].Amount)
    } else if (type.toLowerCase() == 'packaging') {
      return Number(this.shippments[type.toLowerCase()][index].Amount)
    }
    else {

      this.shippments[type][index].Shipment.TaxAmount.Value = this.shippments[type][index].Shipment.TaxAmount.Value == undefined ? 0 : this.shippments[type][index].Shipment.TaxAmount.Value
      this.shippments[type][index].Shipment.RatedPrice.Value = this.shippments[type][index].Shipment.RatedPrice.Value == undefined ? 0 : this.shippments[type][index].Shipment.RatedPrice.Value;
      this.shippments[type][index].Shipment.TotalCharges.Value = this.shippments[type][index].Shipment.TotalCharges.Value == undefined ? 0 : this.shippments[type][index].Shipment.TotalCharges.Value;
      this.shippments[type][index].DiscountAmount = this.shippments[type][index].DiscountAmount == undefined ? 0 : this.shippments[type][index].DiscountAmount;
      return this.shippments[type][index].Amount;
    }
  }

  findTotalByCurrency(type) {
    return this.calculateByCurency(type, this.displayCurrency);
  }

  getCurrency(shipment) {
    if (this.checkCurrency(shipment.CashOnDelivery.Code) && shipment.CashOnDelivery.Value != 0) {
      return shipment.CashOnDelivery.Code;
    } else if (this.checkCurrency(shipment.Customs.Code) && shipment.Customs.Value != 0) {
      return shipment.Customs.Code;
    } else if (this.checkCurrency(shipment.RatedPrice.Code) && shipment.RatedPrice.Value != 0) {
      return shipment.RatedPrice.Code;
    }

    return this.branchCurrencyCode;
  }

  checkCurrency(currency: string) {
    return currency != null && currency.trim() != ''
  }

  calculateByCurency(type: string, currency: string) {
    const allShipments = Array.from(this.shipmentsByCurrency[currency]).filter((x: any) => x.type == type).map((x: any) => x.shipmentNo ? x.shipmentNo : undefined)
    let total = 0;

    Object.keys(this.shippments).forEach(key => {
      const value = this.shippments[key];
      delete this.shippments[key];
      this.shippments[key.toLowerCase()] = value;
    });

    allShipments.forEach((shipment: any) => {
      let index = -1;

      if (type == 'outbound' || type == 'dropoff' || type.toLowerCase() == 'packaging') {
        index = this.shippments[type.toLowerCase()].findIndex((ele: any) => ele.Shipment.Number === shipment);
      } else {
        index = this.shippments[type.toLowerCase()].findIndex((ele: any) => ele.Shipment.Number === shipment && this.getCurrency(ele.Shipment) == currency);
      }

      if (index > -1) {
        total = total + this.fixTotalDecimals(this.findVerticalTotal(type, index))
      }
    })

    return this.fixTotalDecimals(total);
  }

  findAllTotal2(type) {
    var total = 0;
    var index = 0;

    while (index < this.shippments[type.toLowerCase()].length) {
      total = total + this.fixTotalDecimals(this.findVerticalTotal(type, index))
      index++;
    }
    return this.fixTotalDecimals(total);
  }

  fixTotalDecimals(value: any = 0) {
    if (value != 0 && value != null && value != '0') {
      value = parseFloat(value).toFixed(2);
      return parseFloat(value);
    }
    else
      return 0;
  }
  isCreditCardNumberValid = true;
  isCreditCardTypeIdValid = true;
  isTrminalNumberValid = true;
  isAuthorizationCode = true;

  creditCardDetailsValidation() {
    this.isCreditCardNumberValid = true;
    this.isCreditCardTypeIdValid = true;
    this.isTrminalNumberValid = true;
    this.isAuthorizationCode = true;
    if (this.creditCardNumber.length != 4) {
      this.isCreditCardNumberValid = false;
    }
    if (this.creditCardTypeId == -1) {
      this.isCreditCardTypeIdValid = false;
    }
    if (this.terminalNumber == undefined || this.terminalNumber == '') {
      this.isTrminalNumberValid = false;
    }
    if (this.authorizationCode == undefined || this.authorizationCode == '') {
      this.isAuthorizationCode = false
    }
    if (!this.isCreditCardTypeIdValid || !this.isCreditCardNumberValid || !this.isTrminalNumberValid || !this.isAuthorizationCode) {
      if (this.ccSelected == 'selected')
        return true;
    }
  }

  openPosCalculator() {
    var total = this.findAllTotal2('misc') + this.findAllTotal2('inbound') + this.findTotalByCurrency('outbound') + this.findTotalByCurrency('dropoff') + this.findAllTotal2('Packaging');

    if (total != 0 && this.payingAmount == '0' && this.cashSelected == "selected") {
      let cash: HTMLElement = <HTMLElement>document.querySelector('.armx-cash');
      let payingAmmount: HTMLElement = <HTMLElement>document.querySelector('#payingAmmount')
      cash.click();
      payingAmmount.focus();
      return true;
    }
    return false;
  }

  checkOut() {
    if (this.isCheckoutButtonDisabled) {
      return;
    }

    if (this.openPosCalculator()) {
      return;
    }

    const isUpdate = this.updatePaymentDetails();

    if (isUpdate === false) {
      return;
    }

    var c = this.shippments.inbound as any[];
    if (c.length > 0) {
      var inboundShipment = c[0];
      c.forEach((item) => {
        item.Shipment.PodCustomerName = this.consigneeObject.consigneeName;
        item.Shipment.PodCustomerMobile = this.consigneeObject.phoneNumber;
        item.Shipment.PodCustomerEmail = this.consigneeObject.emailAddress;
        item.Shipment.PodCustomerIdNumber = this.consigneeObject.customerPodIdNumber;
      });
      inboundShipment.Shipment.GrandTotal.Value = inboundShipment.Shipment.RatedPrice.Value - Number(inboundShipment.DiscountAmount) + inboundShipment.Shipment.CashOnDelivery.Value + inboundShipment.Shipment.Customs.Value + Number(inboundShipment.Shipment.TaxAmount.Value);
      inboundShipment.Shipment.TotalCharges.Value = inboundShipment.Shipment.Customs.Value;

      if (inboundShipment.Shipment.CustomsCharges) {
        var totalCustomsCharges = 0;
        inboundShipment.Shipment.CustomsCharges.forEach((item, index) => {
          totalCustomsCharges += item.Amount;
        })
        inboundShipment.Shipment.TotalCharges.Value = totalCustomsCharges;
      }
      else
        inboundShipment.Shipment.TotalCharges.Value = 0;
    }
    //handle dropoff shipments
    var d = this.shippments.dropoff as any[];
    if (d.length > 0) {
      d.forEach((item) => {
        item.Shipment.GrandTotal.Value = item.Amount;
        item.Shipment.GrandTotal.Code = item.Shipment.NewCost.Code;
      });
    }

    var PackagingShipmentonCheckout = this.shippments.packaging as any[];

    if (PackagingShipmentonCheckout.length > 0) {
      PackagingShipmentonCheckout.forEach((item) => {
        item.Shipment.Amount = item.Amount;
      });
    }

    var details = c.concat(this.shippments.outbound).concat(this.shippments.misc).concat(d).concat(PackagingShipmentonCheckout);
    if (this.creditCardTypeId != -1)
      var creditCardDescription = this.creditCardTypes.filter(x => x.CreditCardTypeId == this.creditCardTypeId)[0].Description;

    var checkoutObjs = [];

    this.paymentDetailsByCurrency.forEach((item: any) => {
      checkoutObjs.push(this.generateCheckoutObj(item, details));
    })
    this.loader.start();
    this.isCheckoutButtonDisabled = true;
    //Calling Checkout API
    this.receiptService.checkout(checkoutObjs, (res: any) => {
      console.log('checkoutObjs', checkoutObjs);

      this.loader.stop();
      this.isCheckoutButtonDisabled = false;
      if (res.length > 0) {
        res.forEach((oneRes) => {
          if (oneRes.Number) {
            let outbounds = this.shippments.outbound as any[];
            outbounds.forEach((item, i) => {
              if (item.commercialInvoice != null) {
                let shipment = oneRes.Details.find(m => m.Comments == `Outbound ${item.Shipment.Number}`).Shipment
              }
            })

            if (this.hasInboundShipment && this.hasOutboundShipment) {
              this.uploadfiles("id", 1, 1, oneRes.ReceiptId)
              if (this.hasInboundShipment)
                this.uploadfiles("signature", 3, 1, oneRes.ReceiptId)
              else
                this.uploadfiles("ci", 2, 2, oneRes.ReceiptId)
            }
            else if (this.hasInboundShipment) {
              this.uploadfiles("id", 1, 1, oneRes.ReceiptId)
              this.uploadfiles("signature", 3, 1, oneRes.ReceiptId)
            }
            else if (this.hasOutboundShipment) {
              this.uploadfiles("id", 1, 2, oneRes.ReceiptId)
              this.uploadfiles("ci", 2, 2, oneRes.ReceiptId)
            }
            // print the reports
            var reports = oneRes.Reports as any[];

            if (reports != null) {
              reports.forEach((item) => {

                var _this = this;


                var temp = "data:application/pdf;base64,";
                this.locationService.getBase64(item.Url, (res) => {
                  /*this.base64Output = temp.concat(res);*/
                  this.base64Output = res;
                  var fileNameIndex = item.Url.lastIndexOf("/") + 1;
                  var filename = item.Url.substr(fileNameIndex);

                  console.log(item.Url);
                  _this.sss.print({
                    'documentId': item.Type.ReportTypeId,
                    'fileName': filename,
                    'fileData': this.base64Output
                  });
                  window.open(item.Url, "_blank");
                }, (err) => {

                })

                this.loader.stop();
                this.isCheckoutButtonDisabled = false;

              })
            }
          }
        })
      }

      //******************************** Scanning **************************************
      //Constants
      var SourceID = 1;
      var CustomerIDFileName = "CustomerID.png";

      //*************************************Inbound***************************************
      if (this.shippments.inbound.length > 0) {

        this.shippments.inbound.forEach((item) => {
          setTimeout(() => {
            var AWBNumber = item.Shipment.Number;

            //CustomerID*********************************

            //get CustomerID file from DB by AWB
            if (item.hasCustomerID) {
              this.DocumentService.GetDocumentByAWB(SourceID, AWBNumber, CustomerIDFileName, (res) => {
                var CustomerIDfileContent: any = [];
                CustomerIDfileContent = res;
                //add file by ID but send the AWB and in the backend will get shipment ID and replace it **Customer ID**
                var IdResult: any = [];
                if (CustomerIDfileContent != null) {
                  this.DocumentService.AddDocumentByID(SourceID, AWBNumber, CustomerIDFileName, CustomerIDfileContent.$value, (res) => {
                    IdResult = res;
                    //delete file by AWB
                    if (IdResult.isSuccessful) {
                      //this.DocumentService.DeleteDocumentByAWB(SourceID, AWBNumber, CustomerIDFileName, (res) => {
                      //}, (err) => {

                      //})
                    }


                  }, (err) => {
                    this.toaster.error("Failed to add document by ID")
                  })


                }

              }, (err) => {

              })
            }

            //for now, in Inbound shipments we dont have attach commercial invoices, but keep it in case we need it in future
            //******************Commercial Invoice*****************
            //  InvoiceFileName = AWBNumber.concat("_Invoice.png");
            //  var CommercialInvoicefileContent : any = [];
            //  //get Commercial Invoice file from DB by AWB  
            //  if(item.commercialInvoice.length > 0){
            //    CommercialInvoicefileContent = this.DocumentService.GetDocumentByAWB(SourceID,AWBNumber,InvoiceFileName,(res) => {
            //     console.log("res", res);
            //    }, (err) => { 

            //    })
            //    }

            //    //add file by ID but send the AWB and in the backend will get shipment ID and replace it **Commercial Invoice**
            //    var CommercialResult : any = [];
            //    if(CommercialInvoicefileContent != null){
            //      CommercialResult = this.DocumentService.AddDocumentByID(SourceID,AWBNumber,InvoiceFileName,CommercialInvoicefileContent.value,(res) => {
            //       console.log("res", res);
            //      }, (err) => { 

            //      })

            //      //delete file by AWB
            //      if(CommercialResult.isSuccessful){
            //        this.DocumentService.DeleteDocumentByAWB(SourceID,AWBNumber,InvoiceFileName,(res) => {
            //        console.log("res", res);
            //        }, (err) => { 

            //        })
            //       }

            //     }
          }, 6000);
        })//end of ForEach

      } //end of Inbound

      // *************************************Outbound*************************************
      if (this.shippments.outbound.length > 0) {

        this.shippments.outbound.forEach((item) => {
          setTimeout(() => {
            var AWBNumber = item.Shipment.Number;
            //************************CustomerID*********************************
            //get CustomerID file from DB by AWB
            if (item.hasCustomerID) {
              this.DocumentService.GetDocumentByAWB(SourceID, AWBNumber, CustomerIDFileName, (resultt) => {
                var CustomerIDfileContent: any = [];
                CustomerIDfileContent = resultt;

                //add file by ID but send the AWB and in the backend will get shipment ID and replace it **Customer ID**

                if (CustomerIDfileContent != null) {
                  this.DocumentService.AddDocumentByID(SourceID, AWBNumber, CustomerIDFileName, CustomerIDfileContent.$value, (res) => {
                    var IdResult: any = [];
                    IdResult = res;


                    //delete file by AWB
                    if (IdResult.isSuccessful) {
                      //this.DocumentService.DeleteDocumentByAWB(SourceID, AWBNumber, CustomerIDFileName, (res) => {
                      //}, (err) => {

                      //})
                    }
                  }, (err) => {
                    this.toaster.error("Failed to add document by ID")
                  })

                }


              }, (err) => {

              })

            }


            //*************************Commercial Invoice*************************
            //get Commercial Invoice file from DB by AWB if it exists
            if (item.commercialInvoice != null) {
              var InvoiceFileName = AWBNumber.concat("_Invoice.png");

              this.DocumentService.GetDocumentByAWB(SourceID, AWBNumber, InvoiceFileName, (res) => {
                var CommercialInvoicefileContent: any = [];

                CommercialInvoicefileContent = res;

                //add file by ID but send the AWB and in the backend will get shipment ID and replace it **Commercial Invoice**

                if (CommercialInvoicefileContent != null) {
                  this.DocumentService.AddDocumentByID(SourceID, AWBNumber, InvoiceFileName, CommercialInvoicefileContent.$value, (res) => {
                    var CommercialResult: any = [];
                    CommercialResult = res;

                    //delete file by AWB
                    if (CommercialResult != null) {
                      //this.DocumentService.DeleteDocumentByAWB(SourceID, AWBNumber, InvoiceFileName, (res) => {
                      //}, (err) => {

                      //})
                    }
                  }, (err) => {
                    this.toaster.error("Failed to add document by ID")
                  })



                }


              }, (err) => {

              })
            }
          }, 6000);
        })//end of ForEach

      }//end of Outbound

      this.router.navigate(['/dashboard/cashier/receipts'])
    }, (err) => {
      console.log(err);
      this.loader.stop();
      this.isCheckoutButtonDisabled = false;
      this.toaster.error(err.error[0].Message)
    })
  }

  //the Checkout API Object Creation is handled
  generateCheckoutObj(paymentObj: IPaymentDetails, details: any) {
    if (paymentObj.paymentDetails.type == 'cc' && paymentObj.paymentDetails.details.CreditCardType.CreditCardTypeId != -1)
      var creditCardDescription = this.creditCardTypes
        .filter(x => x.CreditCardTypeId == paymentObj.paymentDetails.details.CreditCardType.CreditCardTypeId)[0].Description;

    let tDetails = [];

    paymentObj.shipments.forEach((shipment: string) => {
      let i = details.find((x: any) => {
        if (x.Shipment.mode && x.Shipment.mode.toLowerCase() == 'inbound') {
          return x.Shipment.Number == shipment && this.getCurrency(x.Shipment) == paymentObj.currency;
        }

        return x.Shipment.Number == shipment;
      });

      if (i) {
        tDetails.push(i);
      }
    })

    var checkoutObj = {
      ReceiptId: 0,
      Number: '',
      TotalAmount: {
        Code: paymentObj.currency,
        Value: this.findAllTotal2('misc') + this.calculateByCurency('inbound', paymentObj.currency) + this.calculateByCurency('outbound', paymentObj.currency) + this.calculateByCurency('dropoff', paymentObj.currency) + this.calculateByCurency('Packaging', paymentObj.currency)
      },
      PaymentType: {
        ReceiptPaymentTypeId: paymentObj.paymentDetails.receiptPaymentTypeId,
        Description: creditCardDescription
      },
      PaymentDetails: {},
      Details: tDetails
    }

    if (paymentObj.paymentDetails.type == 'cash') {
      checkoutObj.PaymentDetails = null;
      checkoutObj.PaymentType = {
        ReceiptPaymentTypeId: 1,
        Description: paymentObj.paymentDetails.type
      }
    }
    else if (paymentObj.paymentDetails.type == 'cc') {
      checkoutObj.PaymentType = {
        ReceiptPaymentTypeId: 2,
        Description: "Credit Card"
      }
      checkoutObj.PaymentDetails = {
        TerminalNumber: paymentObj.paymentDetails.details.TerminalNumber,
        AuthorizationCode: paymentObj.paymentDetails.details.AuthorizationCode,
        CreditCardNumber: paymentObj.paymentDetails.details.CreditCardNumber,
        RRN: paymentObj.paymentDetails.details.RRN,
        CreditCardType: {
          CreditCardTypeId: paymentObj.paymentDetails.details.CreditCardType.CreditCardTypeId,
          Description: creditCardDescription
        }
      }
    }

    return checkoutObj;
  }

  paymentType = 'cash';

  selectPaymentType(paymentType) {
    switch (paymentType) {
      case 'cash':
        this.ccSelected = '';
        this.cashSelected = 'selected';
        this.qrSelected = '';
        this.paymentType = 'cash';
        break;
      case 'cc':
        this.cashSelected = '';
        this.ccSelected = 'selected';
        this.qrSelected = '';
        this.paymentType = 'cc';
        this.paymentIntegration();
        break;
      case 'qr':
        this.cashSelected = '';
        this.ccSelected = '';
        this.qrSelected = 'selected';
        this.paymentType = 'qr';
        this.paymentWithQrCode();
        break;
    }
  }

  uploadfiles(type, typeId, ReceiptTypeId, receiptId) {

    if (this.files) {
      if (this.files[type] != null && this.files[type] != "") {
        var base64ImageContent = this.files[type].replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
        var base64File = { "FileContentsAsBase64": base64ImageContent };
        if (type == "id" || type == "signature")
          this.receiptService.uploadReceiptAttachment(receiptId, type, ReceiptTypeId, base64File, (res) => {

          }, (err) => {

            this.toaster.error(err.error[0].Message)
          })
        else if (type == "ci") {
          this.receiptService.uploadReceiptInvoice(receiptId, '2', base64File, (res) => {

          }, (err) => {

            this.toaster.error(err.error[0].Message)
          })
        }
      }
    }
  }
  uploadCommercialInvoice(receiptId, shipmentId, commercialInvoice) {

    var base64ImageContent = ''
    if (commercialInvoice.changingThisBreaksApplicationSecurity)
      base64ImageContent = commercialInvoice.changingThisBreaksApplicationSecurity.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
    else
      base64ImageContent = commercialInvoice.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
    var base64File = { "FileContentsAsBase64": base64ImageContent };
    this.receiptService.uploadReceiptInvoice(receiptId, shipmentId, base64File, (res) => {

    }, (err) => {

      this.toaster.error(err.error[0].Message)
    })
  }
  getCreditCardTypes() {
    this.receiptService.getCreditCardTypes(
      (res) => {
        this.creditCardTypes = res;
      },
      (err) => { console.log(err) });
  }

  checkTotalAmount() {
    return !this.isTotalZero;
  }


  previous() {
    this.previousTrigger.emit(false);
  }

  base64ToBlob(base64, mime) {
    mime = mime || '';
    var sliceSize = 1024;
    var byteChars = window.atob(base64);
    var byteArrays = [];

    for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
      var slice = byteChars.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: mime });
  }
  settings = JSON.parse(sessionStorage.getItem("user")).Settings as any;
  branchSettings = JSON.parse(sessionStorage.getItem("branchSettings")) as any[];

  paymentIntegration() {
    if (!this.settings.PaymentDeviceEnabled) { return; }

    let code = this.settings.PaymentDeviceCode;
    let amount = this.findAllTotal();
    let currency = this.displayCurrency;
    let terminal = this.settings.PaymentDeviceTerminal;

    this.receiptService.integrateWithPayment(code, amount, currency, terminal, (res) => {


      if (res.WebResponseStatus == "Success") {
        if (res.PaymentStatus == "Approved") {

          this.creditCardNumber = res.CardLast4Digits;
          this.creditCardTypeId = 1;//this.creditCardTypes.filter(x => x.Description.toLowerCase().replace(/ /g, "") == res.CardType.toLowerCase().replace(/ /g, ""))[0].CreditCardTypeId;
          this.terminalNumber = res.TerminalNumber;
          this.authorizationCode = res.AuthCode;
          this.rrn = res.RRN == null ? "" : res.RRN;
        }

        else if (res.PaymentStatus == "Declined") {
          alert("Payment status is declined");
        }

        else if (res.PaymentStatus == "Unknown") {
          alert("Payment status is unknown");
        }
        else if (res.PaymentStatus == "cancelled by user") {
          alert("Payment status is cancelled by user");
        }
      }
      else {
        if (res.webResponseStatus == "Success") {
          if (res.paymentStatus == "Approved") {
            this.creditCardNumber = res.cardLast4Digits;
            this.creditCardTypeId = 1;//this.creditCardTypes.filter(x => x.Description.toLowerCase().replace(/ /g, "") == res.CardType.toLowerCase().replace(/ /g, ""))[0].CreditCardTypeId;
            this.terminalNumber = res.terminalNumber;
            this.authorizationCode = res.authCode;
            this.rrn = res.rrn == null ? "" : res.rrn;
          }
          else if (res.paymentStatus == "Declined") {
            alert("Payment status : declined");
          }

          else if (res.paymentStatus == "Unknown") {
            alert("Payment status : unknown");
          }
          else if (res.paymentStatus == "cancelled by user") {
            alert("Payment status : cancelled by user");
          }
          // else if(res.paymentStatus){
          // alert(`Payment status : ${res.paymentStatus}`);
          // }
        } else {
          const jsonString = JSON.stringify(res, null, 2);
          alert(`Error ${jsonString}`);
        }

      }
    },

      (res) => {
        if (res.errorMessage) {
          alert(res.errorMessage);
        } else {
          alert(res.ErrorMessage);
        }

      });
  }

  paymentWithQrCode() {

    let shipments = this.shippments.inbound.map(item => item.Shipment);


    let requestBody = {
      "MobileNumber": this.consigneeObject.phoneNumber,
      "CountryCode": JSON.parse(sessionStorage.getItem('company')).BranchCompanyCountryCode,
      "ShipmentIds": shipments.map(item => item.ShipmentId).join(','),
      "CurrencyCode": this.branchCurrencyCode,
      "City": JSON.parse(sessionStorage.getItem('branch')).branch.BranchCity,
      "Email": this.consigneeObject.emailAddress,
      "Source": "POS",
      "PaymentType": "Inbound"
    };

    this.expressAccountingService.GetQRPaymentLink(requestBody, (res) => {

      this.qrLink = res.RealUrl;
    },

      (res) => {
      });

  }

  recheck() {
    var AWBNumbers = [];

    for (let shipment of this.shippments.inbound) {
      AWBNumbers.push(shipment.Shipment.Number);
    }

    this.receiptService.getShipmentDetails(JSON.stringify(AWBNumbers.join(',')), 1, false,
      (res) => {
        for (let result of res) {
          let existingShipment = this.shippments.inbound.filter(x => x.Shipment.Number == result.Shipment.Number)[0];

          existingShipment.Shipment.RatedPrice = result.Shipment.RatedPrice;
          existingShipment.Shipment.CashOnDelivery = result.Shipment.CashOnDelivery;
          existingShipment.Shipment.Customs = result.Shipment.Customs;
        }

        this.changeDetection.detectChanges();
      },

      (res) => {


      });

  }

  payingAmount = '0';
  dotDisabled = '';
  findChange() {
    var change = this.fixDecimals(this.findAllTotal2('misc') + this.findTotalByCurrency('inbound') + this.findTotalByCurrency('outbound') + this.findTotalByCurrency('dropoff') + + this.findTotalByCurrency('packaging') - Number(this.payingAmount));
    return -change;
  }
  tempNumber = this.payingAmount;
  makeNumber(number) {

    switch (number) {
      case '.':
        var numberToMake = this.payingAmount + '' + number;
        this.payingAmount = numberToMake;
        break;
      case 'c':
        this.payingAmount = '0';
        break;
      case 'bk':
        if (this.payingAmount.length > 1) {
          this.payingAmount = this.payingAmount.substr(0, this.payingAmount.length - 1)
        }
        else {
          this.payingAmount = '0';
        }
        break;
      default:
        if (this.payingAmount != null && this.payingAmount[0] != undefined) {
          this.payingAmount = this.payingAmount[0] == '0' ? number : this.payingAmount + '' + number;
        }
        else {
          this.payingAmount = number;
        }

        break;

    }
    this.tempNumber = this.payingAmount;
    this.dotDisabled = this.payingAmount.includes('.') ? 'disabled' : '';
  }
  disableTheDot(event: KeyboardEvent) {
    if (isNaN(Number(this.payingAmount))) {
      this.payingAmount = this.tempNumber;
      return;
    }
    else {
      this.tempNumber = this.payingAmount
    }
    if (event.which == 13) {
      let okbtn: HTMLElement = <HTMLElement>document.querySelector('.btn-ok');
      okbtn.click();
    }
    if (this.payingAmount != null && this.payingAmount[0] != undefined) {
      this.dotDisabled = this.payingAmount.includes('.') ? 'disabled' : '';
    }

  }
}
